export const {client_id, client_secret, redirect_uri} = {
    client_id: "cf0b8e1d7920435ea65ff312483e21e9",
    client_secret: "4a55676ce43d403694bfecfcd1e316d6",
    //redirect_uri: "http://localhost:8080/spotify",
    redirect_uri: "https://msap-429e1.web.app/spotify",
    }